import { Plus as PlusIcon } from "lucide-react";

import { CreateDatasetPopover } from "@/shared/components/CreateDatasetButton/CreateDatasetPopover";
import { RobotoButton } from "@/shared/foundation/primitives";
import { usePopupState } from "@/shared/hooks/usePopupState";

/**
 * "New Dataset" action for the datasets page. Opens the existing
 * create-dataset popover — which owns the form, submission, and post-create
 * navigation — instead of routing to `/datasets/create`.
 */
export function CreateDatasetPopoverButton() {
  const popup = usePopupState();

  return (
    <>
      <RobotoButton
        variant="primary"
        icon={<PlusIcon aria-hidden="true" />}
        onClick={(event) => popup.open({ anchorEl: event.currentTarget })}
      >
        New Dataset
      </RobotoButton>
      <CreateDatasetPopover
        anchorEl={popup.anchor}
        handleClose={popup.close}
        // The button sits at the right of the toolbar, so align the popover's
        // right edge to the button's right edge — it opens leftward and stays
        // on screen (left-edge alignment would overflow and get repositioned).
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: -15, horizontal: "right" }}
      />
    </>
  );
}
